import { render } from "./termsofuse.vue?vue&type=template&id=6c2a07ca"
import script from "./termsofuse.js?vue&type=script&lang=js"
export * from "./termsofuse.js?vue&type=script&lang=js"

import "./termsofuse.vue?vue&type=style&index=0&id=6c2a07ca&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__